import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import colors from "core/resources/theme/colors";
import { AiOutlineFall, AiOutlineRise } from "react-icons/ai";
import { MdOutlineAttachMoney, MdBarChart } from "react-icons/md";
import Card1Horizontal from "ui/components/Cards/Card1Horizontal";
import { SimpleGrid } from "@chakra-ui/layout";
import moment from "moment";

function DashboardMovimentacoes({
  totais,
  isLoading,
  dataFim,
  showSaldo = true,
}: {
  totais?: {
    despesa: number;
    receita: number;
    resultado: number;
    saldo: number;
    saldoHoje: number;
    totalCentroDeCusto?: number;
  };
  isLoading?: boolean;
  dataFim?: string;
  showSaldo?: boolean;
}) {
  const {
    resultado = 0,
    receita = 0,
    despesa = 0,
    saldo = 0,
    totalCentroDeCusto = null,
  } = totais || {};

  return (
    <>
      <SimpleGrid
        columns={{
          sm: 1,
          md: 4,
          lg: typeof totalCentroDeCusto === "number" ? 5 : 4,
        }}
        gap="16px"
        mb="32px"
      >
        <Card1Horizontal
          icon={<AiOutlineRise fontSize="24px" color={colors.blue} />}
          color={colors.blue}
          bg={colors.blue100}
          description="Total de receitas"
          title={`R$ ${formatCurrency(receita)}`}
          loading={isLoading}
        />

        <Card1Horizontal
          icon={<AiOutlineFall fontSize="24px" color={colors.red} />}
          color={colors.red}
          bg={colors.red100}
          description="Total de despesas"
          title={`R$ ${formatCurrency(despesa)}`}
          loading={isLoading}
        />

        <Card1Horizontal
          loading={isLoading}
          icon={
            <MdOutlineAttachMoney
              fontSize="24px"
              color={
                resultado > 0
                  ? colors.blue
                  : resultado === 0
                    ? colors.gray
                    : colors.red
              }
            />
          }
          color={
            resultado > 0
              ? colors.blue
              : resultado === 0
                ? colors.gray
                : colors.red
          }
          bg={
            resultado > 0
              ? colors.blue100
              : resultado === 0
                ? colors.neutral
                : colors.red100
          }
          description="Resultado"
          title={`R$ ${formatCurrency(resultado)}`}
        />

        {showSaldo ? (
          <Card1Horizontal
            icon={<MdBarChart fontSize="24px" color={colors.green} />}
            color={colors.green}
            bg={colors.green100}
            description={`Saldo em ${moment(dataFim).format("DD/MM/YYYY")}`}
            title={`R$ ${formatCurrency(saldo)}`}
            loading={isLoading}
          />
        ) : null}
        {typeof totalCentroDeCusto === "number" && (
          <Card1Horizontal
            icon={<MdBarChart fontSize="24px" color={colors.green} />}
            color={colors.green}
            bg={colors.green100}
            description={`Saldo do centro de custo em ${moment(dataFim).format("DD/MM/YYYY")}`}
            title={`R$ ${formatCurrency(totalCentroDeCusto)}`}
            loading={isLoading}
          />
        )}
      </SimpleGrid>
    </>
  );
}

export default DashboardMovimentacoes;
